var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 21C3.5 21.9665 4.2835 22.75 5.25 22.75L36.75 22.75C37.7165 22.75 38.5 21.9665 38.5 21C38.5 20.0335 37.7165 19.25 36.75 19.25L5.25 19.25C4.2835 19.25 3.5 20.0335 3.5 21Z",
    fill: "#121314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01256 19.7625C3.32915 20.446 3.32915 21.554 4.01256 22.2374L16.2626 34.4874C16.946 35.1709 18.054 35.1709 18.7374 34.4874C19.4209 33.804 19.4209 32.696 18.7374 32.0126L7.72487 21L18.7374 9.98744C19.4209 9.30402 19.4209 8.19598 18.7374 7.51256C18.054 6.82915 16.946 6.82915 16.2626 7.51256L4.01256 19.7625Z",
    fill: "#121314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.6a7956f9e91b1c66cfad6428eb246f99.svg";
export { ForwardRef as ReactComponent };